import __request__ from "routing/request";
export function listConfigurationVariables() {
  return __request__("GET", "/sidecar/configuration_variables", null, {}, {
    "Accept": ["application/json"]
  });
}
export function createConfigurationVariable(JSONbody) {
  return __request__("POST", "/sidecar/configuration_variables", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function validateConfigurationVariable(JSONbody) {
  return __request__("POST", "/sidecar/configuration_variables/validate", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function updateConfigurationVariable(id, JSONbody) {
  return __request__("PUT", `/sidecar/configuration_variables/${id}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteConfigurationVariable(id) {
  return __request__("DELETE", `/sidecar/configuration_variables/${id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getConfigurationVariablesConfigurations(id) {
  return __request__("GET", `/sidecar/configuration_variables/${id}/configurations`, null, {}, {
    "Accept": ["application/json"]
  });
}
